module.exports = __webpack_public_path__ + "static/media/logo.ff3fa215.png";